import script from "./FoodTinder.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodTinder.vue?vue&type=script&setup=true&lang=js"

import "./FoodTinder.vue?vue&type=style&index=0&id=5d3d2690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d3d2690"]])

export default __exports__